/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationInterface } from './api-configuration';

import { AktiviteterService } from './services/aktiviteter.service';
import { AlertService } from './services/alert.service';
import { AnsoegningService } from './services/ansoegning.service';
import { AnvendelsesOmraaderService } from './services/anvendelses-omraader.service';
import { DokumentationerService } from './services/dokumentationer.service';
import { EjendommeService } from './services/ejendomme.service';
import { ErrorsService } from './services/errors.service';
import { HealthService } from './services/health.service';
import { KommunerService } from './services/kommuner.service';
import { ListePunkterService } from './services/liste-punkter.service';
import { LokaliteterService } from './services/lokaliteter.service';
import { MapService } from './services/map.service';
import { MyndighederService } from './services/myndigheder.service';
import { ProfilService } from './services/profil.service';
import { ProjekterService } from './services/projekter.service';
import { ProjekterAktiviteterService } from './services/projekter-aktiviteter.service';
import { ProjekterBilagService } from './services/projekter-bilag.service';
import { ResourcerService } from './services/resourcer.service';
import { SagService } from './services/sag.service';
import { SigneringService } from './services/signering.service';
import { UserService } from './services/user.service';
import { VirksomhederService } from './services/virksomheder.service';

/**
 * Provider for all Api services, plus ApiConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    ApiConfiguration,
    AktiviteterService,
    AlertService,
    AnsoegningService,
    AnvendelsesOmraaderService,
    DokumentationerService,
    EjendommeService,
    ErrorsService,
    HealthService,
    KommunerService,
    ListePunkterService,
    LokaliteterService,
    MapService,
    MyndighederService,
    ProfilService,
    ProjekterService,
    ProjekterAktiviteterService,
    ProjekterBilagService,
    ResourcerService,
    SagService,
    SigneringService,
    UserService,
    VirksomhederService
  ],
})
export class ApiModule {
  static forRoot(customParams: ApiConfigurationInterface): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}

